module.exports = __webpack_public_path__ + "media/footer/linkedin-936f5db4.svg";